<template>
  <div class="customTable text-center caption">
    <table style="width:100%">

      <!-- Headers -->
      <tr>
        <td
          v-for="item in Object.keys(headers)"
          :key="item.id"
          class="pa-2 table-header text-center font-weight-bold"
        >
          {{ headers[item] }}
        </td>
      </tr>
      
      <!-- Inspections -->
      <template v-if="inspection && damages.length">
        <tr v-for="element in damages" :key="element.id">
          <td
            v-for="item in Object.keys(headers)"
            :key="item.id"
            class="pa-2"
          >
            {{ item === 'repair_stages' && element[item] ? element[item].join(', ') : element[item] }}
          </td>
        </tr>
      </template>

      <!-- Reparation -->
      <tr v-else>
        <td
          v-for="item in Object.keys(headers)"
          :key="item.id"
          class="pa-2"
        >
          {{ item === 'repair_stages' && damage[item] ? damage[item].join(', ') : damage[item] }}
        </td>
      </tr>

      <!-- Repair Stages -->
      <tr v-if="!inspection">
        <td :colspan="3" class="pa-2 table-header text-center font-weight-bold">
          Etapas de reparación
        </td>
        <td :colspan="3">
          {{ damage.repair_stages && damage.repair_stages.join(', ') }}
        </td>
      </tr>
      

    </table>
  </div>
</template>

<script>
export default {
  props: {
    damage: { type: Object, default: () => {} },
    damages: { type: Array, default: () => [] },
    inspection: { type: Boolean, default: false }
  },
  data: () => ({
    headers: {
      location: 'Posicion',
      radius: 'Radio (m)',
      ba_distance: 'Dist. al B.A (cm)',
      bs_distance: 'Dist. al B.S (cm)',
      severity: 'Daño',
      damage_type: 'Código de daño',
    }
  }),
}
</script>
